import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Investing from "./sections/Investing";
import Philosophy from "./sections/Philosophy";
import Mission from "./sections/Mission";
import InvestmentProcess from "./sections/InvestmentProcess";
import Focus from "./sections/Focus";
import Partner from "./sections/Partner";
import Conversation from "./sections/Conversation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Investing />
      <Philosophy />
      <Mission />
      <InvestmentProcess />
      <Focus />
      <Partner />
      <Conversation />
      <Footer />
    </div>;
}